export default __webpack_public_path__ + "static/media/next_section.e156813c.svg";